import { Moment, moment } from '@seiue/moment'
import { DateTypeEnum } from 'packages/sdks-next/growp'

/**
 * moment转化为指定格式的字符串
 * @param momentData - moment
 * @param type - 类型
 * @returns 转化后的字符串
 */
export const momentToString = (
  momentData: Moment | null,
  type?: DateTypeEnum
) => {
  if (momentData && moment.isMoment(momentData)) {
    const format =
      type === DateTypeEnum.Time ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'
    return momentData.format(format)
  }
  return undefined
}

/**
 * 字符串时间转化为moment时间
 * @param str - 字符串
 * @param type - 类型
 * @returns moment时间
 */
export const stringToMoment = (str?: string, type?: DateTypeEnum) => {
  const format = type === DateTypeEnum.Time ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'
  if (str && moment(str, format, true).isValid()) {
    return moment(str)
  }
  return null
}
